module.exports = __webpack_public_path__ + "static/img/item-l_c_strawberry.bd4278e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_c_strawberry.png
// module id = Djzb
// module chunks = 1